<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before:always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_table_of_contents_1"><span>Acknowledgments</span></h1>
<p class="P_Normal">My heartfelt thanks go to Susan and Becky for the feedback and wonderful words of encouragement. My unending appreciation to the wonderful people at Dreamspinner who make it all real. Thank you.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?07fd93b2